import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  status: 'idle',
  error: null,
  columns: [],
  filters: {
    search: '',
    visibility: [],
  },
  fields: [],
  selectedFields: [],
  selectedColumns: ['videoTitle', 'uploadedAt', 'privacyStatus', 'operation'],
};

// Redux slice
const playlistVideoSlice = createSlice({
  name: 'playlistVideo',
  initialState,
  reducers: {
    setSelectedColumns: (state, action) => {
      state.selectedColumns = action.payload;
    },
    setFields: (state, action) => {
      state.fields = action.payload;
    },
    setColumns: (state, action) => {
      state.columns = action.payload;
    },
    updateFields: (state, action) => {
      state.fields = action.payload;
    },
    updateFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload, // Merge new filters with existing ones
      };
    },
    resetFilters: (state) => {
      state.filters = {}; // Reset filters
    },
  },
});

export const {
  updateFilters,
  resetFilters,
  updateFields,
  setFields,
  setSelectedColumns,
  setColumns,
} = playlistVideoSlice.actions;

export default playlistVideoSlice.reducer;
